module.exports = __webpack_public_path__ + "static/img/104.87dd70f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210317/104.jpg
// module id = /3YW
// module chunks = 0